<template>
  <div class="gmf-checkbox" :class="{'gmf-checkbox-checked': modelValue}" @click.stop>
    <input type="checkbox" :checked="modelValue" :disabled="disabled" @change="onChange">
    <Icon v-if="modelValue" icon="checkmark" />
  </div>
</template>

<style>
.gmf-checkbox {
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: var(--gmf-rounding);
  border-radius: min(var(--gmf-rounding), 4px);
  background: var(--gmf-col-white);
  display: inline-block;
  line-height: 0 !important;
  border: 1px solid var(--gmf-col-gray);
  margin: 0;
  flex-shrink: 0;
}
.gmf-checkbox-checked {
  background: var(--gmf-highlight-col);
  border: none;
}
.gmf-checkbox input {
  position: absolute;
  opacity: 0 !important;
  inset: 0;
  cursor: pointer;
}
.gmf-checkbox .gmf-icon {
  width: 100%;
  height: 100%;
  pointer-events: none;
  --gmf-icon-color: var(--gmf-col-white);
}
</style>

<script>
import Icon from '@/components/Icon';

export default {
  props: ['modelValue', 'disabled'],
  components: {Icon},
  methods: {
    onChange (evt) {
      this.$emit('update:modelValue', evt.target.checked);
    },
  },
};
</script>
